import { RatingFilled } from '@teko/ds-icon';
import { Row, themeColor } from '@teko/ds-mobile';
import React from 'react';

interface StarRatingProps {
  value: number;
  max?: number;
  starSize?: number;
  ratedColor?: string;
  unratedColor?: string;
  gap?: number;
}

export const StarRating: React.FC<StarRatingProps> = (props) => {
  const {
    value,
    max = 5,
    starSize = 20,
    ratedColor = themeColor.support,
    unratedColor = themeColor.divider,
    gap = 2,
  } = props;

  const stars = Array.from({ length: max }, (_, i) => i + 1);
  const fullStars = Math.floor(value);
  const starPercentage = value - fullStars;
  const hasHalfStar = starPercentage >= 0.1 && starPercentage < 1;

  return (
    <Row align="middle" width="fit-content" style={{ gap: gap }}>
      {stars.map((star) => {
        if (star <= fullStars) {
          // full star
          return <RatingFilled key={star} size={starSize} color={ratedColor} />;
        } else if (star === fullStars + 1 && hasHalfStar) {
          // half star
          return (
            <div
              key={star}
              style={{
                position: 'relative',
                width: starSize,
                height: starSize,
              }}
            >
              {/* background star */}
              <RatingFilled
                size={starSize}
                color={unratedColor}
                style={{ position: 'absolute', top: 0, left: 0 }}
              />
              {/* half filled overlay */}
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: `${starPercentage * 100}%`,
                  height: '100%',
                  overflow: 'hidden',
                }}
              >
                <RatingFilled
                  size={starSize}
                  color={ratedColor}
                  style={{ position: 'absolute', top: 0, left: 0 }}
                />
              </div>
            </div>
          );
        } else {
          // empty star
          return (
            <RatingFilled key={star} size={starSize} color={unratedColor} />
          );
        }
      })}
    </Row>
  );
};
